<template>
<v-menu offset-x >
  <template v-slot:activator="{ on }">
    <v-btn small outlined outline @click='get' v-on='on' slot='activator' class='py-0 pr-0'  >
      🎉 Birthdays
      <v-btn class='pa-0' small icon >
        <v-icon>keyboard_arrow_down</v-icon>
      </v-btn>
    </v-btn>
  </template>
  <v-card width=350 >
    <v-list dense class='pa-0 pb-3'>
      <v-subheader class='overline'>{{ $t('titles.today') }}</v-subheader>
      <v-list-tile
        v-for='person in birthdaysToday'
        v-if='person.patient'
        :to='`/clients/r/${person.relationship_id}`'
        :key='`today-${person.relationship_id}`' >
        <v-list-tile-content>
          <v-list-tile-title>
            {{person.patient.first_name}} {{person.patient.last_name}}
          </v-list-tile-title>
          <v-list-tile-sub-title >
            {{ getString(person.patient.date_of_birth) }}
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile
        v-if='!request.loading && birthdaysToday.length === 0' >
        <v-list-tile-content>
          <v-list-tile-title>{{ $t('nothing.today') }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider class='mt-3' ></v-divider>
      <v-subheader class='overline'>{{ $t('titles.month') }}</v-subheader>
      <v-list-tile
        v-for='person in birthdays'
        v-if='person.patient'
        :to='`/clients/r/${person.relationship_id}`'
        :key='`month-${person.relationship_id}`' >
        <v-list-tile-content>
          <v-list-tile-title>
            {{person.patient.first_name}} {{person.patient.last_name}}
          </v-list-tile-title>
          <v-list-tile-sub-title >
            {{ getString(person.patient.date_of_birth) }}
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile
        v-if='!request.loading && birthdays.length === 0' >
        <v-list-tile-content>
          <v-list-tile-title>{{ $t('nothing.thismonth') }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>

    <request-status
      :request="request"
      :message200="false" />

  </v-card>
</v-menu>
</template>
<script>
import {DateTime} from 'luxon'

export default {
  name: 'BirthdayBar',
  data () {
    return {
      request: {
        resource: 'ag.spaces',
        extra: 'birthdays'
      },
      month: null
    }
  },
  computed: {
    birthdays () {
      return this.getObjectPath(this.request, 'result.results', [])
    },
    birthdaysToday () {
      let vm = this
      return this.birthdays.filter((person) => {
        let bdateString = this.getObjectPath(person, 'patient.date_of_birth')
        return vm.isToday(bdateString)
      })
    }
  },
  methods: {
    get () {
      this.$request('get', this.request)
      // this.$medicalaidguru.resource('birthdays').id(this.reqId).list()
    },
    isToday (dateString) {
      let today = DateTime.local().toFormat('d LLL')
      let bday = DateTime.fromISO(dateString).toFormat('d LLL')
      return (today === bday)
    },
    getString (dateString) {
      let today = DateTime.local()
      let bday = DateTime.fromISO(dateString)
      let bdayFormatted = bday.toFormat('LL dd')
      let bdayFormattedForHumans = bday.toFormat('d LLL')
      let todayFormatted = today.toFormat('LL dd')
      let age = Math.round(today.diff(bday, 'years').years)
      if (bdayFormatted === todayFormatted) { return `Turns ${age} today` }
      if (bdayFormatted < todayFormatted) { return `Turned ${age} on ${bdayFormattedForHumans}` }
      if (bdayFormatted > todayFormatted) { return `Turns ${age} on ${bdayFormattedForHumans}` }
    }
  },
  i18n: {
    messages: {
      en: {
        titles: {
          today: 'Birthdays today',
          month: 'Birthdays this month'
        },
        nothing: {
          today: 'No birthdays today',
          thismonth: 'No birthdays this month'
        }
      },
      es: {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// BirthdayBar.vue?404f23b1